<template>
  <div class="v-orders container">
    <!-- action-bar -->
    <action-bar class="head-bar action-bar" :b="true" @back="back">
      <div class="left" slot="left">
        <button @click.stop="$router.push('/home/hall')">{{ '购彩大厅' }}</button>
      </div>

      <div class="title" slot="title">
        <span>{{ title }}</span>
      </div>

    </action-bar>

    <!-- main-table -->
    <div class="v-main">
      <v-table :data="data" :columns="columns" @goto="goto">
        <span slot="count" slot-scope="{row}">{{ row.count }}</span>
        <template slot="class2_class3" slot-scope="{data}">
             <span>{{data.class2}}({{data.class3}})</span>
        </template>
      </v-table>
    </div>

    <!--  -->

  </div>
</template>

<script>
import ActionBar from '@/components/action-bar';
import VTable from '@/components/table';
import { history4 } from "@/service/report";
import objectPath from 'object-path';

export default {
  name: "v-settled",
  components: {ActionBar, VTable},
  data() {
    return {
      title: '今日',
      date: '',
      data: []
    }
  },

  methods: {
    goto(item) {
      // this.$router.push({path:'/home/settled',query: item})
    },
    back() {
      this.$router.go(-1);
    }
  },

  created() {
    let query = this.$route.query;
    this.title += '--';

    if (query.period) {
      this.title += query.period
    }

    history4({period: query.period, lottery_type: query.lottery_type}).then(res => {
      const resData = objectPath.get(res, 'data.data') || [];
      this.data = (resData || []).map(item => {
        if(item.status==3){
         item.status = '<span class="red">取消</span>';
        }
        else{
          item.status = '<span class="green">有效</span>';
        }
        item.results = item.result >= 0 ? '<span style="color:red" >' + item.result + '</span>' : '<span style="color:#0f0" >' + item.result + '</span>';
        return item;
      });
    }).catch(() => {
      this.data = [];
      this.$toast && this.$toast.center('加载失败');
    });
  },

  computed: {
    columns() {
      return [
        /*{
          title: '订单号',
          key: 'order_id',
          width: '15%',
          align: 'center'
        },*/
        {
          title: '时间',
          key: 'date_time',
          width: '20%',
          align: 'center'
        },

        {
          title: '期号',
          key: 'period',
          width: '10%',
          align: 'center'
        },
        {
          title: '类型',
          key: 'class2',
          width: '10%',
          align: 'center'
        },
        {
          title: '明细',
          key: 'class3',
          width: '10%',
          align: 'center'
        },
        {
          title: '赔率',
          key: 'odds',
          width: '10%',
          align: 'center'
        },
        {
          title: '投注',
          key: 'money',
          width: '10%',
          align: 'center'
        },
        {
          title: '退水',
          key: 'rebate',
          width: '10%',
          align: 'center'
        },
        {
          title: '输赢',
          key: 'win',
          width: '10%',
          align: 'center'
        },
        {
          title: '状态',
          key: 'status',
          width: '10%',
          align: 'center'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.v-orders {
  .head-bar {
    z-index: 100;
    position: relative;

    .left {
      width: 140px;

      > button {
        height: 60px;
      }
    }

    .title {
      display: flex;
      text-align: center;
      align-items: center;
      font-weight: bold;
      justify-content: center;

      > button {
        width: 50px;
        height: 50px;
        border: 1px solid #b40f06;
        position: relative;
        margin-left: 10px;
        border-radius: 25px;

        &:after {
          top: 22px;
          left: 13px;
          display: block;
          content: "";
          position: absolute;
          border-top: 10px solid #fff;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: none;
          transition: transform 0.2s linear;
        }
      }
    }

    button {
      color: #fff;
      border: 1px solid #b70a00;
      padding: 0 16px;
      position: relative;
      font-size: 24px;
      background: #e8291d;
      background: -webkit-gradient(linear, 0 0, 0 70%, from(#f94539), to(#e8291d));
      box-shadow: 0 2px 2px #fc7f77 inset;
      border-radius: 10px;
    }
  }

  .v-main {
    position: relative;
    box-sizing: border-box;
    padding-bottom: 60px;
  }

  .count-box {
    height: 100px;
    font-size: 24px;
    background: #fffbec;
    flex-shrink: 0;
    border-top: 1px solid #dfdddd;
    box-sizing: border-box;

    p {
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e2d9b5;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/settledMemo/index.vue